import { getPosHubIntegrationStatus } from 'api/merchants';
import React, {
  createContext, useContext, useEffect, useMemo, useState,
} from 'react';
import { useParams } from 'react-router-dom';

const PosHubIntegrationContext = createContext({
  posHubIntegrated: false,
  posHubDisabled: false,
  posHubStatusLoading: true,
});

export function usePosHubIntegration() {
  return useContext(PosHubIntegrationContext);
}

export function PosHubIntegrationProvider({ children }) {
  const { id: merchantId } = useParams();
  const [posHubIntegrated, setPosHubIntegrated] = useState(false);
  const [posHubDisabled, setPosHubDisabled] = useState(false);
  const [posHubStatusLoading, setPosHubStatusLoading] = useState(true);

  useEffect(() => {
    setPosHubStatusLoading(true);
    getPosHubIntegrationStatus(merchantId)
      .then((data) => {
        const isPosEnabled = data?.pos_enabled !== false;
        setPosHubDisabled(!isPosEnabled);
        // Treat as "integrated" only when POS is actively connected and enabled.
        setPosHubIntegrated(data?.is_connected === true && isPosEnabled);
      })
      .catch(() => {
        setPosHubIntegrated(false);
        setPosHubDisabled(false);
      })
      .finally(() => setPosHubStatusLoading(false));
  }, [merchantId]);

  const value = useMemo(
    () => ({ posHubIntegrated, posHubDisabled, posHubStatusLoading }),
    [posHubIntegrated, posHubDisabled, posHubStatusLoading],
  );

  return (
    <PosHubIntegrationContext.Provider value={value}>
      {children}
    </PosHubIntegrationContext.Provider>
  );
}
